export const FABRIC_INFO_TEST_IDS = {
  PANEL_CLOSE: 'fabricInfo-panel-close',
  IMAGE: 'fabricInfo-image',
  IMAGE_MAXIMIZE: 'fabricInfo-image-maximize',
  ZOOM_OVERLAY: 'fabricInfo-zoom-overlay',
  ZOOM_IMAGE: 'fabricInfo-zoom-image',
  ZOOM_CLOSE: 'fabricInfo-zoom-close',
  HEADER: 'fabric-info-header',
  LOW_STOCK_LABEL: 'fabric-info-low-stock-label',
  COMPOSITION: 'Composition',
  WEIGHT: 'Weight',
  SEASON: 'Season',
  FABRIC_CODE: 'Fabric code',
  WOVEN_BY: 'Woven by',
  BOOKLET_AND_SLIDER: 'Booklet and Slider',
} as const;

